export const SET_STUDENT_CLASSES = 'SET_STUDENT_CLASSES';

function setStudentClasses(students) {
    const studentClasses = {};
    students.forEach((student) => {
        studentClasses[student.userProfileId] = student.classroomId;
    });
    return {
        type: SET_STUDENT_CLASSES,
        payload: studentClasses
    };
}

export default {
    setStudentClasses
};



// WEBPACK FOOTER //
// ./containers/participation/all-classes/student-classes/student-classes-actions.js